import React from 'react';
import {
    Tab, Nav, Col, NavItem, Row, Form, FormGroup, ControlLabel
} from 'react-bootstrap';
import Select from 'react-select';
import SweetAlert from "react-bootstrap-sweetalert";
import TutoresSubTab from './PreSelectionComponents/TutoresSubTab.jsx';
import CoordinadorSubTab from './PreSelectionComponents/CoordinadorSubTab.jsx';
import ProyectosSubTab from './PreSelectionComponents/ProyectosSubTab.jsx';
import ListSubTab from './PreSelectionComponents/ListSubTab.jsx';

class PreSelectionTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      assignedProjects: [],
      activeTab: 'tutores',
      projectTab: null,
      convocatoriaFiltro: {value: this.props.convocatorias[0], label: this.props.convocatorias[0]},
    }
    this.saveEvaluation = this.saveEvaluation.bind(this);
    this.validateProjects = this.validateProjects.bind(this);
    this.getProyects = this.getProyects.bind(this);
    this.refresh = this.refresh.bind(this);
    this.onChangeConvocatoriaFilter = this.onChangeConvocatoriaFilter.bind(this);
    this.generateConvocatoriaOptions = this.generateConvocatoriaOptions.bind(this);
  }
  componentWillMount() {
    this.getProyects(this.props.convocatorias[0]);
  }

  getProyects(convocatoria) {
    this.props.incubationService
      .getAssignedProyects(convocatoria)
      .then(res => {
        this.setState({
          assignedProjects: res.preseleccion,
        });
      })
      .catch(err => {
        this.props.setError((<div>Ha ocurrido un error mientras se cargaban los datos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }

  onChangeConvocatoriaFilter(item) {
    this.setState({convocatoriaFiltro: item});
    if (item && item !== '') {
      this.getProyects(item.value);
    } else {
      this.getProyects();
    }
  }

  generateConvocatoriaOptions() {
    return this.props.convocatorias.map((item) => {
      return {value: item, label: item};
    });
  }

  refresh(tab) {
    this.setState({ assignedProjects: [], projectTab: tab });
    this.getProyects(this.state.convocatoriaFiltro.value);
  }

  saveEvaluation(projects) {
    this.props.incubationService
      .saveEvaluation(projects)
      .then(res => {
        this.props.showAlert(
            <SweetAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="Evaluaciones guardadas"
              onConfirm={() => this.props.hideAlert()}
              onCancel={() => this.props.hideAlert()}
              confirmBtnBsStyle="info"
              confirmBtnText="Aceptar"
            >
              {'Cambios guardados satisfactoriamente!'}
            </SweetAlert>
          );
      })
      .catch(err => {
        this.props.setError((<div>Ha ocurrido un error mientras se guardaban los datos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }
  validateProjects() {
    if (!this.state.assignedProjects) {
      return (<div>No hay registros</div>);
    } else if (this.state.assignedProjects.length > 0) {
      return (
        <TutoresSubTab
          projects={this.state.assignedProjects} saveEvaluation={this.saveEvaluation}
          showAlert={this.props.showAlert} setError={this.props.setError}
          incubationService={this.props.incubationService} hideAlert={this.props.hideAlert}
          refresh={(tab) => this.refresh(tab)} activeTab={this.state.projectTab}
          convocatorias={this.props.convocatorias} getProyects={this.getProyects}
        />
      );
    } else {
      return (<div></div>);
    }
  }
  render() {
    return(
      <div >
        <Tab.Container id="pre-selections-tabs" defaultActiveKey="tutores">
          <Row className="clearfix">
            <Col sm={2} style={{padding:'0'}} className="visible-xs-block">
              <Nav bsStyle="pills" stacked>
                <NavItem onClick={() => this.setState({ activeTab: 'tutores' })} eventKey="tutores">Proy. Asignados</NavItem>
                <NavItem onClick={() => this.setState({ activeTab: 'proyectos' })} eventKey="proyectos">Calificación Individual</NavItem>
                {this.props.currentRole === 'Coordinador' &&
                  <NavItem onClick={() => this.setState({ activeTab: 'coordinador' })} eventKey="coordinador">Coordinador</NavItem>
                }
              </Nav>
            </Col>
            <Col sm={2} className="hidden-xs">
              <Nav bsStyle="pills" stacked>
                <NavItem onClick={() => this.setState({ activeTab: 'tutores' })} eventKey="tutores">Proy. Asignados</NavItem>
                <NavItem onClick={() => this.setState({ activeTab: 'proyectos' })} eventKey="proyectos">Calificación Individual</NavItem>
                {this.props.currentRole === 'Coordinador' &&
                  <NavItem onClick={() => this.setState({ activeTab: 'coordinador' })} eventKey="coordinador">Coordinador</NavItem>
                }
                {this.props.currentRole === 'Coordinador' &&
                  <NavItem onClick={() => this.setState({ activeTab: 'coordinador2' })} eventKey="coordinador2">Listado</NavItem>
                }
              </Nav>
            </Col>
            <Col sm={10} style={{border: 'solid 1px #59CAED'}}>
              <Tab.Content animation>
                { this.state.activeTab === 'tutores' &&
                  <Tab.Pane eventKey="tutores">
                    <Form horizontal>
                      <Row>
                        <Col md={4}>
                          <FormGroup>
                            <Col componentClass={ControlLabel} md={6} style={{textAlign:'left', paddingTop: '7px'}}>
                              Convocatoria:
                            </Col>
                            <Col md={6}>
                              <Select
                                placeholder="Seleccione"
                                closeOnSelect={true}
                                name="type"
                                value={this.state.convocatoriaFiltro}
                                options={this.generateConvocatoriaOptions()}
                                onChange={(value) => this.onChangeConvocatoriaFilter(value)}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Form>
                    {this.validateProjects()}
                  </Tab.Pane>
                }
                {this.state.activeTab === 'proyectos' &&
                  <Tab.Pane eventKey="proyectos">
                    <ProyectosSubTab
                      incubationService={this.props.incubationService} setError={this.props.setError}
                      convocatorias={this.props.convocatorias}
                    />
                  </Tab.Pane>
                }
                {this.state.activeTab === 'coordinador' && this.props.currentRole === 'Coordinador' &&
                  <Tab.Pane eventKey="coordinador">
                    <CoordinadorSubTab
                      incubationService={this.props.incubationService} setError={this.props.setError}
                      preIncubate={this.props.preIncubate} showAlert={this.props.showAlert}
                      hideAlert={this.props.hideAlert} convocatorias={this.props.convocatorias}
                      archive={this.props.archive}
                    />
                  </Tab.Pane>
                }
                {this.state.activeTab === 'coordinador2' && this.props.currentRole === 'Coordinador' &&
                  <Tab.Pane eventKey="coordinador2">
                    <ListSubTab
                      incubationService={this.props.incubationService} setError={this.props.setError}
                      preIncubate={this.props.preIncubate} showAlert={this.props.showAlert}
                      convocatorias={this.props.convocatorias}
                      history={this.props.history}
                    />
                  </Tab.Pane>
                }
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    );
  }
}

export default PreSelectionTab;



// WEBPACK FOOTER //
// ./src/views/Incubation/PreSelectionTab.jsx